// extracted by mini-css-extract-plugin
export default {"f":"_6b656b660b","main":"c4b8cbf8bf","btn":"_86e70ea6da","w":"a153555ddf","h":"_7ae2054d8b","lh25":"_0b5d8cf56b","wb":"_3fc9476031","b":"f55b4d037d","bx":"f965808771"};